import { resolve } from 'core-js/fn/promise';
import {
  Toast,Dialog
} from 'vant';

export const loading = (flag) => {
  if (flag) {
      Toast.loading({ 
          mask: true,
          message: '加载中...'
      });
  } else {
      Toast.clear();
  }
}
/**
* 拨打电话
* @param phone 电话号码
*/
export const callPhone = (phone) => {
Dialog.confirm({
  title: '温馨提示',
  message: '确定拨打：'+ phone,
})
  .then(() => {
    // on confirm
window.location.href = "tel:"+phone;
  })
  .catch(() => {
    // on cancel
  });
}

/*
* 验证手机号是否合格
* true--说明合格
*/
export function isPhone(phoneStr) {
let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
if (!myreg.test(phoneStr)) {
  return false;
} else {
  return true;
}
}

/*
* 验证身份证号是否合格
* true--说明合格
*/
export function isIdCard(idCardStr) {
let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
if (idcardReg.test(idCardStr)) {
  return true;
} else {
  return false;
}
}

/**
* 验证车牌号是否合格
* true--说明合格
*/
export function isVehicleNumber(vehicleNumber) {
let xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
let creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
if (vehicleNumber.length == 7) {
  return creg.test(vehicleNumber);
} else if (vehicleNumber.length == 8) {
  return xreg.test(vehicleNumber);
} else {
  return false;
}
}

/*
* 验证字符串是否为空（也不能为纯空格）
* true--说明为空， false--说明不为空
*/
export function isEmptyString(string) {
if (
  string == undefined ||
  typeof string == 'undefined' ||
  !string ||
  string == null ||
  string == '' ||
  /^\s+$/gi.test(string)
) {
  return true;
} else {
  return false;
}
}

/*
* 生日转为年龄（精确到月份）
*/
export function birsdayToAge(birsday) {
let aDate = new Date();
let thisYear = aDate.getFullYear();
let bDate = new Date(birsday);
let brith = bDate.getFullYear();
let age = thisYear - brith;
if (aDate.getMonth() == bDate.getMonth()) {
  if (aDate.getDate() < bDate.getDate()) {
    age = age - 1;
  }
} else {
  if (aDate.getMonth() < bDate.getMonth()) {
    age = age - 1;
  }
}
return age;
}

/**
* 判断数据类型
* @param {any} val - 基本类型数据或者引用类型数据
* @return {string} - 可能返回的结果有，均为小写字符串
* number、boolean、string、null、undefined、array、object、function等
*/
export function getType(val){
//判断数据是 null 和 undefined 的情况
if (val == null) {
  return val + "";
}
return typeof(val) === "object" ?
    Object.prototype.toString.call(val).slice(8, -1).toLowerCase() :
    typeof(val);
}

/*
* 验证是否为数字
*/
export function isNumber(n) {
return !isNaN(parseFloat(n)) && isFinite(n);
}

/*
* 是否为数组
*/
export function isArray(obj) {
return Object.prototype.toString.call(obj) === '[object Array]';
}

/*
* 是否空数组
*/
export function isArrayEmpty(val) {
if (val && val instanceof Array && val.length > 0) {
  return false;
} else {
  return true;
}
}

/*
* 获取url参数字符串
* 没有返回null
*/
export function getQueryString(name) {
let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
let r = window.location.search.substr(1).match(reg);
if (r != null) {
  return unescape(r[2]);
}
return null;
}

/*
* 递归深拷贝
*/
export function deepCopy(obj) {
let result = Array.isArray(obj) ? [] : {};
for (let key in obj) {
  if (obj.hasOwnProperty(key)) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      result[key] = deepCopy(obj[key]);
    } else {
      result[key] = obj[key];
    }
  }
}
return result;
}

/**
* 去除参数空数据（用于向后台传递参数的时候）
* @param {Object} obj [参数对象]
*/
export function filterEmptyData(obj) {
for (let prop in obj) {
  obj[prop] === '' ? delete obj[prop] : obj[prop];
}
return obj;
}

/**
* @desc  函数防抖，用于将多次执行变为最后一次执行
* @param {function} func - 需要使用函数防抖的被执行的函数。必传
* @param {Number} wait - 多少毫秒之内触发，只执行第一次，默认1000ms。可以不传
*/
// export function debounce(fn, delay) {
// delay = delay || 1000; //默认1s后执行
// let timer = null;
// return function () {
//   let context = this;
//   let arg = arguments;
//   if (timer) {
//     clearTimeout(timer);
//   }
//   timer = setTimeout(() => {
//     fn.apply(context, arg);
//   }, delay);
// };
// }

/**
* 节流函数, 用于将多次执行变为每隔一段时间执行
* @param fn 事件触发的操作
* @param delay 间隔多少毫秒需要触发一次事件
*/
export function throttle2(fn, delay) {
let timer = null;
return function () {
  let context = this;
  let args = arguments;
  if (!timer) {
    timer = setTimeout(function () {
      fn.apply(context, args);
      clearTimeout(timer);
    }, delay);
  }
};
}
/**
 *  防抖
 * @param {Object} fn 
 * @param {Number} delay 
 * 调用 let XXX = delayDither((argv)=>{}, 600)
 * XXX()
 */
export function delayDither(delay = 600) {
  let timer = null;
  return function (fn) {
    if (timer) {
      clearTimeout(timer)
    }
    const _that = this;
    let argv = arguments;
    timer = setTimeout(function () {
      fn.apply(_that,argv)
    }, delay)
  }
}